import React from 'react';
import Select from '../Select/Select';
import { CLIENT_DOCUMENT_ISSUED_BY } from '../../constants';

const SelectClientIssuer = ({ ...props }) => {
  return <Select options={CLIENT_DOCUMENT_ISSUED_BY} label={'ÐÐµÐ¼ Ð²ÑÐ´Ð°Ð½'} placeholder={'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°'} {...props} />;
};

export default SelectClientIssuer;
